// extracted by mini-css-extract-plugin
export default {"appointmentTime":"vJkNAAn7jMLBBJRiyb6v"};